// Template
NP.tmpl = {
	// 서비스 시작vServerId : '15',vCharId : '40185',

	openGuestbook : '#{=NP.openCharacterGuestbook(it)}#',
	openGroupGuestbook: '#{=NP.openGroupGuestbook(it)}#',
	open : '<article class="article openServiceInfo">\
<a href="#{=NP.prflUri( it.o )}#" class="thumb">\
<img src="#{=NP.sfile( it.o )}#" alt="#{=it.oNm}#"></a><div class="content">\
<a href="#{=NP.prflUri( it.o )}#" class="js_mProfile nickname" data-np=\'{"id":"#{=it.o}#"}\'>#{=it.oNm}#</a>님의 Sandbox가 열렸습니다.</div></article>',
	openGroup : '<article class="article openServiceGroupInfo"><a class="thumb"><img src="' + NP.RESOURCE_URL + 'icon/nc.gif" alt=""></a>\
<div class="content">[#{=NP.dt.gNm}#] 샌드박스가 열렸습니다. 앞으로 즐거운 이야기를 나누어 보세요.</div></article>',
	systemErr : '<div class="systemMsg"><span class="groupname">죄송합니다. 에러가 발생했습니다. 잠시 후 다시 접속해주시기 바랍니다.</div>',
	closedGroup : '<div class="systemMsg"><span class="groupname">[#{=it.gNm || it.oNm}#]</span><br>레기온 방명록은 비공개 입니다.<br/>\
<a id="guestbookOpenBtn" style="display:none;" class="btn_rect emphasis">비공개 설정 해제</a></div>',
	closedCharacter : '<div class="systemMsg"><span class="charname">[#{=it.oNm}#]</span>님의 캐릭터 방명록은 비공개 입니다.<br/>\
<a id="guestbookOpenBtn" style="display:none;" class="btn_rect emphasis">비공개 설정 해제</a></div>',
	closedFrdCharacter : '<div class="systemMsg"><span class="charname">[#{=it.oNm}#]</span>님은 캐릭터 방명록을 친구에게만 공개하고 있습니다.<br>\
<a class="charSandboxLinkBtn" href="' + 'https://sandbox.plaync.com/' + '#{=it.o}#"><span class="charname">[#{=it.oNm}#]</span>님과 친구가 되어보세요.</a></div>',
	article : '<article class="article" data-gameId="#{=it.post.postTxtTorgGameId}#" data-postTorg="#{=it.postTorg}#" data-postTxtServClfSeq="#{=it.post.postTxtServClfSeq}#" >\
#{=NP.articleThumb(it)}#\
<div class="identity">\
#{=NP.articleNick(it)}#\
</div>\
#{=( !it.orgActType )? "<div class=\'wrap_menu\'><a class=\'btn\'>이 글 메뉴</a><menu class=\'context\'></menu></div>": ""}#\
<div class="content">#{=it.post.postTxtLongCont}# \
<div class="info">\
#{=NP.articleInfo(it, it.post.creDttm, it.post.postTxtTorgNm)}#\
</div>\
</div>\
#{= ( it.post.siempre ) ? "<p class=\'viewOrigin\'><a>... 더 보기</a><span style=\'display:none\'>" + it.post.siempre + "</span></p>" : ""}#\
#{= ( it.photoList !== null && it.photoList && it.photoList.length ) ? NP.Image.setUI( it.photoList ) : ""}#\
<!--#{=NP.likeBy( it )}#-->\
#{=NP.Button.setUI( it )}#\
#{=NP.Reply.setUI( it )}#</article>',
	articleExt : '<article class="article" data-postTorg="#{=it.postTorg}#" data-postTxtTorgGameId="#{=it.post.postTxtTorgGameId}#" data-postTxtServClfSeq="#{=it.post.postTxtServClfSeq}#">\
#{=NP.articleThumb(it)}#\
<div class="identity">\
#{=NP.articleNick(it)}#\
</div>\
#{=( !it.orgActType )? "<div class=\'wrap_menu\'><a class=\'btn\'>이 글 메뉴</a><menu class=\'context\'></menu></div>": ""}#\
<div class="content">\
<div class="title"><a href="#{=it.post.postTxtTorgUrl.replace("http://", "https://")}#">#{=it.post.postTxtTitl.replace(/</g,"&lt;").replace(/>/g,"&gt;")}#</a></div>\
<a href="#{=it.post.postTxtTorgUrl.replace("http://", "https://")}#">#{=it.post.postTxtLongCont}#</a> \
<div class="info">\
#{=NP.articleToInfo(it, it.post.creDttm, it.post.extPostTxtTorgServNm, it.post.postTxtTorgUrl.replace("http://", "https://"))}#\
</div>\
</div>\
#{=( it.photoList !== null && it.photoList && it.photoList.length ) ? NP.Image.setUI( it.photoList ) : ""}#\
<!--#{=NP.likeBy( it )}#-->\
#{=NP.Button.setUI( it )}#\
#{=NP.Reply.setUI( it )}#</article>',
	// 타인의 이야기에 글을 쓴 경우
	articleTo : '<article class="article" data-postTorg="#{=it.postTorg}#"  data-postTxtTorgGameId="#{=it.post.postTxtTorgGameId}#" data-postTxtServClfSeq="#{=it.post.postTxtServClfSeq}#">\
#{=NP.articleThumb(it)}#\
<div class="identity">\
#{=NP.articleNick(it)}#\
님이 \
#{=NP.articleTo(it)}#\
</div>\
<div class="content">#{=it.post.postTxtLongCont}# \
<div class="info">\
#{=NP.articleInfo(it, it.post.creDttm, it.post.postTxtTorgNm)}#\
</div>\
</div>\
#{=it.post.siempre ? "<p class=\'viewOrigin\'><a>... 더 보기</a><span style=\'display:none\'>" + it.post.siempre + "</span></p>" : ""}#\
#{=( !it.orgActType )? "<div class=\'wrap_menu\'><a class=\'btn\'>이 글 메뉴</a><menu class=\'context\'></menu></div>": ""}#\
#{=( it.photoList !== null && it.photoList && it.photoList.length ) ? NP.Image.setUI( it.photoList ) : ""}#\
<!--#{=NP.likeBy( it )}#-->\
#{=NP.Button.setUI( it )}#\
#{=NP.Reply.setUI( it )}#</article>',
	activity : '<article class="article" data-postTorg="#{=it.postTorg}#" data-postTxtTorgGameId="#{=it.post.postTxtTorgGameId}#" data-postTxtServClfSeq="#{=it.post.postTxtServClfSeq}#">\
#{=NP.articleThumb(it)}#\
<div class="wrap_menu">\
<a class="btn">이 글 메뉴</a>\
<menu class="context"></menu>\
</div>\
<div class="content">#{=it.post.postTxtLongCont}# \
<time>#{=NP.Time( ( it.post.refTimeline && it.post.refTimeline.post.creDttm ) || it.post.creDttm )}#</time>\
</div>\
#{=NP.Article.setUI( it )}#\
#{=NP.Button.setUI( it )}#\
#{=NP.Reply.setUI( it )}#</article>',
	deleteArticle : '<article class="resultAction">삭제된 글입니다.</section>',
	hideArticle : '<article class="resultAction">해당글이 더 이상 표시되지 않습니다.</section>',
	blockArticle : '#{=NP.articleThumb(it)}#\
<div class="content">\
<a href="#{=NP.prflUri( it.wrtPlayncAcctId )}#" class="js_mProfile nickname" data-np=\'{"id":"#{=it.wrtPlayncAcctId}#"}\'>#{=it.wrtPlayncAcctNm}#</a>님을 차단했습니다. <a class="revert">차단해제</a>\
</div>',

	actType : { 
		// 추후 추가 예정
		'PHOTO_REPLY' : ' ',
		'EDIT_GROUP_INTRO' : ' ',
		'EDIT_GROUP_REPR_PHOTO' : ' ',
		'FRIEND' : '<a href="#{=NP.prflUri( it.post.postTxtTorgId )}#" class="thumb"><img src="#{=NP.sfile( it.post.postTxtTorgId )}#" alt=""></a>\
<a href="#{=NP.prflUri( it.post.postTxtTorgId )}#" class="js_mProfile nickname" data-np=\'{"id":"#{=it.post.postTxtTorgId}#"}\'>#{=it.post.postTxtTorgNm}#</a>#{= (it.post.wrtChrtNm !== "" && it.post.wrtChrtNm !== null ) ? "<span class=\'game\'>[" + it.post.wrtChrtNm + "]</span>" : ""}#님이 \
<a href="#{=NP.prflUri( it.post.actTorgId )}#" class="js_mProfile nickname" data-np=\'{"id":"#{=it.post.actTorgId}#"}\'>#{=it.post.actTorgNm}#</a>#{=it.data && it.data.length && it.data[ 3 ] ? "<span class=\'game\'>[" + it.data[ 3 ] + "]</span>" : ""}#님과 친구가 되었습니다.', // 7일
		'ADD_PHOTO' : ' ',

		//타인의 프로필에 글 작성
		'PROFILE_POST' : '<a href="#{=NP.prflUri( it.post.wrtPlayncAcctId )}#" class="js_mProfile nickname" data-np=\'{"id":"#{=it.post.wrtPlayncAcctId}#"}\'>#{=it.post.wrtPlayncAcctNm}#</a>님이 \
<a href="#{=NP.prflUri( it.post.actTorgId )}#" class="js_mProfile nickname" data-np=\'{"id":"#{=it.post.actTorgId}#"}\'>#{=it.post.actTorgNm}#</a>님의 프로필에 \
<a href="/#{=it.post.actTorgId}#?postTxtSeq=#{=it.refTimeline.post.postTxtSeq}#">\
#{=!it.refTimeline.post.postTxtLongCont.length ? "" : "&quot;" + NP.Util.ellipsis( it.refTimeline.post.postTxtLongCont, 500 ) + "&quot;"}# 글</a>을 남겼습니다.',

		// 댓글 작성
		'REPLY' : '<a href="#{=NP.prflUri( it.post.actTorgId )}#" class="js_mProfile nickname" data-np=\'{"id":"#{=it.post.actTorgId}#"}\'>\
#{=it.post.actTorgNm}#</a>님의 글에 \
<a href="/#{=it.refTimeline.post.postTxtTorgId}#?postTxtSeq=#{=it.refTimeline.post.postTxtSeq}#">"#{=NP.Util.ellipsis( it.refData, 500 )}#"</a> 댓글을 작성했습니다.',

		// 구독
		'FOLLOW' : '<a href="#{=NP.prflUri( it.post.wrtPlayncAcctId )}#" class="js_mProfile nickname" \
data-np=\'{"id":"#{=it.post.wrtPlayncAcctId}#"}\'>#{=it.post.wrtPlayncAcctNm}#</a>님이 \
<a href="#{=NP.prflUri( it.post.actTorgId )}#" class="js_mProfile nickname" data-np=\'{"id":"#{=it.post.actTorgId}#"}\'>#{=it.post.actTorgNm}#</a>님을 구독 했습니다.',

		// 프로필 정보 추가
		'ADD_PROFILE_INFO' : '<a href="#{=NP.prflUri( it.post.wrtPlayncAcctId )}#" class="js_mProfile nickname" \
data-np=\'{"id":"#{=it.post.wrtPlayncAcctId}#"}\'>#{=it.post.wrtPlayncAcctNm}#</a>님이 \
#{=it.data[ 0 ]}#에 <a href="/#{=it.post.wrtPlayncAcctId}#/my/profile" class="activity">\
"#{=NP.Util.josa( NP.Util.validate( ( it.data[ 0 ] === "생일" ? NP.conv( it.data[ 1 ] ) : it.data[ 1 ] ) ), 0, \'"</a>\' )}# 추가했습니다.',

		// 프로필 정보 변경
		'EDIT_PROFILE_INFO' : '<a href="#{=NP.prflUri( it.post.wrtPlayncAcctId )}#" class="js_mProfile nickname" \
data-np=\'{"id":"#{=it.post.wrtPlayncAcctId}#"}\'>#{=it.post.wrtPlayncAcctNm}#</a>님이 \
#{=NP.Util.josa( it.data[ 0 ], 0 )}# <a href="/#{=it.post.wrtPlayncAcctId}#/my/profile" class="activity">"\
#{=it.data[ 0 ] !== "생일" ? NP.Util.josa( NP.Util.validate( it.data[ 1 ] ), 1, \'"</a>\' ) : NP.conv( it.data[ 1 ] ) + "&quot;</a>로"}# 변경했습니다.',

		// 프로필 사진 변경
		'EDIT_PROFILE_PHOTO' : '<a href="#{=NP.prflUri( it.post.wrtPlayncAcctId )}#" class="js_mProfile nickname" \
data-np=\'{"id":"#{=it.post.wrtPlayncAcctId}#"}\'>#{=it.post.wrtPlayncAcctNm}#</a>님이 프로필 사진을 변경했습니다.',

		// 닉네임변경
		'CHANGE_NICK' : '<a href="#{=NP.prflUri( it.post.wrtPlayncAcctId )}#" class="js_mProfile nickname" \
data-np=\'{"id":"#{=it.post.wrtPlayncAcctId}#"}\'>#{=it.data[ 0 ]}#</a>님이 닉네임을 변경했습니다. \
이제부터 <a href="#{=NP.prflUri( it.post.actTorgId )}#" class="js_mProfile nickname" \
data-np=\'{"id":"#{=it.post.actTorgId}#"}\'>#{=NP.Util.josa( NP.Util.validate( it.data[ 1 ] ), 2, \'</a>\' )}#고 불러주세요.',

		// 상태 좋아요
		'LIKE_STATUS' : '<a href="#{=NP.prflUri( it.post.wrtPlayncAcctId )}#" class="js_mProfile nickname" \
data-np=\'{"id":"#{=it.post.wrtPlayncAcctId}#"}\'>#{=it.post.wrtPlayncAcctNm}#</a>님이 <a href="#{=NP.prflUri( it.post.actTorgId )}#" \
class="js_mProfile nickname" data-np=\'{"id":"#{=it.post.actTorgId}#"}\'>#{=it.post.actTorgNm}#</a>님의 \
<a href="#{=NP.prflUri( it.post.actTorgId )}#?postTxtSeq=#{=it.post.actTorgPostTxtSeq}#">상태</a>를 좋아합니다.'
	},
	replyWrap : '<ul class="list_comment"></ul>',
	reply : '<li>\
#{=NP.replyThumb(it)}#\
#{=NP.replyNick(it)}#\
 #{=it.rplyTxtCont}#\
<p class="button">\
#{=it.deletable === "Y" ? "<a class=\'delete\' title=\'삭제\'>삭제</a>" : ""}# \
#{=NP.dt.v !== it.wrtPlayncAcctId ? "<a class=\'declare\' title=\'신고\'>신고</a></p>" : ""}#\
<p class="cFeed">\
<time>#{=NP.Time( it.creDttm )}#</time> <span class="bar">|</span> \
<a class="like#{=it.liked ? " on" : ""}#">#{=it.liked ? "좋아요 취소" : "좋아요"}#</a> \
#{=it.likeCnt ? "<a class=\'count\'>" + it.likeCnt + "명</a>" : ""}#\
</p>\
</li>',
	replyForm : '<div class="wrap_form">\
#{=NP.Character.setUI( it )}#\
<div class="comment"><input type="text" placeholder="댓글을 입력해 주세요">\
<a class="emoticon js_tooltip btnEmoticon" data-tooltip="이모티콘 첨부" title="이모티콘 첨부">이모티콘</a></div>\
</div>',
commentBox : '<div class="wrap_feedinfo">\
#{=it.post.rplyTxtCnt > 2 ? "<a class=\'prev\'>이전 댓글 보기</a><a class=\'sort asc\'>처음부터 보기</a></p>" : ""}#</div>',
likeBox : '<div class="wrap_feedinfo">\
#{=it.post.rplyTxtCnt > 2 ? it.post.rplyTxtCnt > 10 ? "<p class=\'nav\'><a class=\'prev\'>이전 댓글 보기</a>\
<a class=\'sort asc\'>처음부터 보기</a></p>" : "<p class=\'nav\'><a class=\'prev\'>" + it.post.rplyTxtCnt + "개의 댓글 모두보기</a></p>" : ""}#</div>',
contextMenu : { // key 는 className 과 일치해야함
		MODIFY : '<li><a class="modify">수정</a></li>',
		DEL_POST : '<li><a class="delete">삭제</a></li>',
		DEL_ACTIVITY : '<li><a class="delete">삭제</a></li>',
		LINK : '<li><a class="link" href="#{=it.currUrl}#postTxtSeq=#{=it.postTxtSeq}#">이 글의 링크</a></li>',
		REPORT : '<li><a class="report">신고</a></li>',
		HIDE : '<li><a class="hide">무시</a></li>',
		FRD_BLOCK : '<li><a class="block">차단</a></li>',
		UNFOLLOW : '<li><a class="unfollow js_btnFollow" follow-acc-id="#{=it.wrtPlayncAcctId}#" follow-action-type="1" data-current="1">구독취소</a></li>'
	},
	button : '<section class="wrap_feed2">\
<div class="wrapBtnComment#{=it.post.rplyTxtCnt >= 1? " on": ""}#">\
<button class="btnComment"><span class="value">댓글</span>\
<strong class="count">#{=it.post.rplyTxtCnt}#</strong></button></div>\
<div class="wrapBtnLike#{=it.post.likeCnt >= 1? " on": ""}# #{=it.post.liked ? " unLike" : ""}#">\
<button class="btnLike"><span class="value">#{=it.post.liked ? "취소" : "좋아요"}#</span></button>\
<button class="btnCount"><span class="count">#{=it.post.likeCnt}#</span></button></div>\
</section>',
	wrapImage : '<section class="wrap_willAddPhoto"><ul><li></li><li></li><li></li><li></li><li></li></ul></section>',
	imageFrame : '<div class="frame_image"><div><img src="' + NP.SANDBOX_URL + 'common/loading_type1.gif" /></div></div> <a class="delete"><span>삭제</span></a>',
	message : {
		notAllowed : '<strong>#{=NP.dt.oNm}#</strong><b>님은 친구에게만 글 작성을 허용하고 있습니다.</b><br /><strong>#{=NP.dt.oNm}#</strong>님과 친구가 되어보세요.',
		restrict : '회원님께서는 제재로 인해 서비스 이용이 중지되었습니다.<br /><a href="http://cscenter.plaync.co.kr"><strong>고객센터 바로가기</strong></a>'
	},
	selectSetOpen: '<div class="js_select selectSetOpen"><em class="js_selected">전체공개</em><div class="js_selector" style="display: none; "><ul>\
<li><label class="checked"><input type="radio" name="a" value="all">전체공개</label></li><li><label>\
<input type="radio" name="a" value="friend">친구공개</label></li></div></div>',
	selectSetChar: '#{=NP.Character.setSelectSetChar( it )}#',
	modalGroupSetting: '<div id="modalGroupSetting" style="display:none;position:absolute;z-index:12;top:20px;right:0;">\
	<section class="modalGuestbookSetting">\
		<header>\
			<span class="group">레기온 방명록 공개 설정</span>\
			<a class="btnCloseLayer">닫기</a>\
		</header>\
		<div class="wrapCont">\
			<form>\
			<ul>\
				<li>\
					<label> <input type="radio" name="groupOpenSetting" value="all"/> 전체공개</label>\
					<span>누구나 글을 보고 작성할 수 있습니다.</span>\
				</li>\
				<li>\
					<label> <input type="radio" name="groupOpenSetting" value="private" /> 비공개</label>\
					<span>아무도 방명록에 접근할 수 없습니다.</span>\
				</li>\
			</ul>\
			</form>\
			<p class="noti">공개 설정 변경 시 이전에 작성된 모든 글들의 공개 설정도 변경됩니다.</p>\
		</div>\
		<div class="wrapBtns">\
			<a class="btn_rect emphasis apply">적용</a>\
			<a class="btn_rect cancel">취소</a>\
		</div>\
	</section>\
</div>',
	modalCharSetting: '<div id="modalCharSetting" style="display:none;position:absolute;z-index:12;top:20px;right:0;">\
	<section class="modalGuestbookSetting">\
		<header>\
			<span class="character">캐릭터 방명록 공개 설정</span>\
			<a class="btnCloseLayer">닫기</a>\
		</header>\
		<div class="wrapCont">\
			<form>\
			<ul>\
				<li>\
					<label> <input type="radio" name="groupOpenSetting" value="all"/> 전체공개</label>\
					누구나 글을 보고 작성할 수 있습니다.\
				</li>\
				<li>\
					<label> <input type="radio" name="groupOpenSetting" value="npfriend"/> NC친구공개</label>\
					NC친구만 글을 보고, 작성 할 수 있습니다.\
				</li>\
				<li>\
					<label> <input type="radio" name="groupOpenSetting" value="private"/> 비공개</label>\
					아무도 방명록에 접근할 수 없습니다.\
				</li>\
			</ul>\
			</form>\
			<p class="noti">공개 설정 변경 시 이전에 작성된 모든 글들의 공개 설정도 변경됩니다.</p>\
		</div>\
		<div class="wrapBtns">\
			<a class="btn_rect emphasis apply">적용</a>\
			<a class="btn_rect cancel">취소</a>\
		</div>\
	</section>\
</div>',
	modalBlockFriend : '<section id="modalBlockFriend" class="ly_modal" style="width:400px">\
		<div class="wrap_blockFriend">\
		    <a class="js_close close">닫기</a>\
		    <dl style="line-height:1">\
		    	<p>차단하면 차단한 친구가 보내는 대화 또는 글을</p>\
		    	<p>받을 수 없으며, 서로의 접속 상태를 확인할 수 없습니다.</p>\
		    	<p>친구가 아닌 경우 친구요청을 받을 수 없습니다.</p>\
		    	<p>(차단 여부는 상대방이 알 수 없습니다.)</p>\
		    </dl>\
		    <div class="wrap_button">\
		        <a class="btn_rect emphasis" block-acc-id="" action-type="1">차단</a>\
		        <a class="js_close btn_rect">취소</a>\
		    </div>\
		</div>\
		</section>',	
	modalDeclareArticle : '<section id="modalDeclareArticle" class="ly_modal">\
		<div class="wrap_declareArticle">\
			<header>신고하기</header>\
			<a class="js_close close">닫기</a>\
			<p class="txt">- 게시물 신고는 하루에 20회까지 가능합니다.</p>\
			<table>\
				<tr>\
					<th>남은신고횟수</th>\
					<td><span class="count"></span> 회</td>\
				</tr>\
				<tr>\
					<th>신고자</th>\
					<td class="reporter"></td>\
				</tr>\
				<tr>\
					<th>신고일시</th>\
					<td class="date"></td>\
				</tr>\
				<tr>\
					<th>신고대상자</th>\
					<td class="target"></td>\
				</tr>\
				<tr>\
					<th>신고사유</th>\
					<td class="list"></td>\
				</tr>\
			</table>\
			<div class="wrap_button">\
				<a class="btn_rect emphasis">신고</a>\
				<a class="btn_rect js_close">취소</a>\
			</div>\
		</div>\
		</section>',
	writeShort : '<section class="wrap_editorShort">\
<div class="wrap_frame">\
<span class="shape radiusLT"></span><span class="shape radiusRT"></span><span class="shape radiusLB"></span><span class="shape radiusRB"></span>\
<div class="textarea">\
<p class="welcome owner"><span>오늘은 어떤 이야기를 나누실래요?</span></p>\
<a class="btn_cancel">올리기 취소</a>\
<textarea id="textarea"></textarea>\
<menu class="addData">\
<li class="photo">\
<div class="frame"><div>\
<a>사진</a>\
</div></div>\
</li>\
</menu>\
</div><div class="wrap_option"></div></div>\
<div class="wrap_button"><button class="btn_write">올리기</button></div>\
</section>',
	noneData: '<section class="wrap_nonedata"><strong>아직 게시물이 없습니다.</strong><br />#{=it.gNm}# 문파 활동에 문파원들과 참여해 보세요</section>'
};
NP.Util.compile( NP.tmpl );